<template>
    <div class="politica-privacidad">
        <h1 class="title">Política de Privacidad</h1>
        <div class="content">
            <h2>1. Recopilación de información</h2>
            <p>
                Recopilamos información personal que usted nos proporciona directamente, como su nombre, dirección de correo electrónico y datos de pago cuando se registra en
                nuestro servicio.
            </p>

            <h2>2. Uso de la información</h2>
            <p>
                Utilizamos la información recopilada para proporcionar, mantener y mejorar nuestros servicios, así como para comunicarnos con usted sobre su cuenta y
                actualizaciones del servicio.
            </p>

            <h2>3. Compartir información</h2>
            <p>No vendemos ni compartimos su información personal con terceros, excepto en los casos descritos en esta política o con su consentimiento.</p>

            <h2>4. Seguridad de datos</h2>
            <p>Implementamos medidas de seguridad diseñadas para proteger su información personal contra acceso no autorizado y uso indebido.</p>

            <h2>5. Sus derechos</h2>
            <p>
                Usted tiene derecho a acceder, corregir o eliminar su información personal. Puede ejercer estos derechos contactándonos a través de los medios proporcionados al
                final de esta política.
            </p>
        </div>
        <div class="button-container">
            <router-link to="/" class="back-button">
                <span class="button-icon">🏠</span>
                Volver a la página principal
            </router-link>
        </div>
        <footer-component />
    </div>
</template>

<script>
import FooterComponent from '@/components/FooterComponent.vue';

export default {
    name: 'PoliticaPrivacidad',
    components: {
        FooterComponent,
    },
};
</script>

<style scoped>
.politica-privacidad {
    max-width: 800px;
    margin: 0 auto;
    padding: 2rem;
    background-color: var(--color-background);
    color: var(--color-text);
}

.title {
    font-size: 2.5rem;
    text-align: center;
    margin-bottom: 2rem;
    color: var(--color-title);
}

.content {
    background-color: var(--color-background-light);
    border-radius: 15px;
    padding: 2rem;
    margin-bottom: 2rem;
}

h2 {
    color: var(--color-accent);
    margin-top: 1.5rem;
    margin-bottom: 1rem;
}

p {
    margin-bottom: 1rem;
    line-height: 1.6;
}

.button-container {
    display: flex;
    justify-content: center;
    margin: 3rem 0;
}

.back-button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0.75rem 1.5rem;
    background-color: var(--color-accent);
    color: var(--color-text);
    text-decoration: none;
    border-radius: 25px;
    font-size: 1rem;
    font-weight: bold;
    transition: all 0.3s ease;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.back-button:hover {
    background-color: var(--color-accent-hover);
    transform: translateY(-2px);
    box-shadow: 0 6px 8px rgba(0, 0, 0, 0.15);
}

.button-icon {
    font-size: 1.2rem;
    margin-right: 0.5rem;
}
</style>
